import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';
import { content } from '../_auth/brand.css';

export const enterpriseBrandContent = style([
  content,
  responsiveStyle({
    mobile: {
      gap: space.s12,
    },
    laptop: {
      gap: space.s24,
    },
  }),
]);

export const synopticLink = style([
  {
    width: 'fit-content',
  },
  responsiveStyle({
    mobile: {
      margin: '0 auto',
    },
    laptop: {
      margin: '0',
    },
  }),
]);
